export default function timelineHelper(data, filter) {
  if (data.length < 1)
    return [
      {
        month: 'No data available - please add published URLS',
        lineData: 0,
        lineDataLabel: '$0',
        barData: 0
      }
    ];
  switch (filter) {
    case 'Last 12 Months':
      return data.slice(2);

    case 'Last 6 Months':
      return data.slice(8);

    case 'Last 3 Months':
      return data.slice(11);

    default:
      return data;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/app/components/value/timelineHelper.js